import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { Icon } from '../../../../../components/UI'

import { selectRole } from '../../../../../routing/fetchingfunction/user/user.reducer'
import { deleteQuiz } from '../../../../../routing/fetchingfunction/quiz/quiz.actions'

const MyQuizTemplate = ({ quizTemplate }) => {
  const dispatch = useDispatch()

  const role = useSelector(selectRole)

  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  const isPastDueDate = useMemo(() => {
    const now = moment()
    const due = moment(quizTemplate.due_date)

    const hours = due.diff(now, 'hour')

    return hours < 0
  }, [quizTemplate])

  const handleFormatDueDate = () => {
    const now = moment()
    const due = moment(quizTemplate.due_date)

    const days = due.diff(now, 'day')

    if (days > 0 || days < 0) {
      return `${Math.abs(days)} day${days > 1 || days < -1 ? 's' : ''}`
    }

    const hours = due.diff(now, 'hour')

    return `${Math.abs(hours)} hour${hours > 1 || hours < -1 ? 's' : ''}`
  }

  const handleDelete = () => {
    setIsDeleteLoading(true)

    dispatch(deleteQuiz(quizTemplate.quiz_template_hash_1)).finally(() => {
      setIsDeleteLoading(false)
    })
  }

  return (
    <div className="w-full rounded-[10px] border-[#FFCA84] border-[1px] p-[20px]">
      <div className="w-full flex items-center justify-between">
        <div className="w-[70%] flex flex-col justify-center items-start">
          <p className="flex-1 text-ellipsis whitespace-nowrap overflow-hidden text-sm font-semibold text-primary-100">
            {quizTemplate.quiz_title}
          </p>

          <div className="w-full flex items-start flex-wrap gap-x-[32px] gap-y-[16px] mt-[20px]">
            <div className="flex items-center">
              <Icon
                name="check-circle-fill"
                color="#1AC057"
                className="w-[24px] h-[24px] mr-[10px]"
              />

              <span className="text-sm font-normal text-primary-100">
                {quizTemplate.questions.length} task{quizTemplate.questions.length > 1 ? 's' : ''}
              </span>
            </div>

            <div className="flex items-center">
              <Icon
                name={isPastDueDate ? 'exclamation-mark-circle' : 'check-circle-fill'}
                color={isPastDueDate ? '#DC2828' : '#1AC057'}
                className={`w-[24px] h-[24px] mr-[10px] ${isPastDueDate ? 'p-[2px]' : ''}`}
              />

              <span className="text-sm font-normal text-primary-100">
                {handleFormatDueDate()} {isPastDueDate ? 'from due date' : 'to complete'}
              </span>
            </div>

            <div className="flex items-center">
              <Icon
                name="check-circle-fill"
                color="#1AC057"
                className="w-[24px] h-[24px] mr-[10px]"
              />

              <span className="text-sm font-normal text-primary-100">
                {quizTemplate.minim_correct_answers} correct answer
                {quizTemplate.minim_correct_answers > 1 ? 's' : ''} to complete
              </span>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-end">
          <Link
            to={`/${role}/settings/my-quiz-templates/edit/${quizTemplate.quiz_template_hash_1}`}
            className="group/edit ml-auto border-[#F67443] border-[1px] bg-[#FDFDFD] rounded-[6px] h-[40px] pl-[7px] pr-[16px] flex items-center hover:bg-[#F67443] transition-colors duration-200 ease"
          >
            <Icon
              name="edit-line"
              className="w-[16px] h-[16px] mr-[6px] text-[#F79009] group-hover/edit:text-white transition-colors duration-200 ease"
            />

            <span className="group-hover/edit:text-white text-primary-100 text-sm font-medium transition-colors duration-200 ease">
              Edit
            </span>
          </Link>

          <button
            disabled={isDeleteLoading}
            className={`ml-[10px] bg-[#EF4343] rounded-[6px] h-[40px] px-[16px] flex items-center hover:bg-[#ae0f0f] transition-all duration-200 ease ${isDeleteLoading ? 'opacity-70' : 'opacity-100'}`}
            onClick={handleDelete}
          >
            <Icon name="delete-bin-line" className="w-[24px] h-[24px] mr-[8px] text-white" />

            <span className="text-white text-sm font-medium">Delete</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default MyQuizTemplate
